import { Node } from "@xyflow/react";
import { atom } from "jotai";

import { DefaultNodeData, NodeData } from "../types";
import { nodesAtom } from "./nodesAtom";

export const uniqueAgentIdsAtom = atom((get) => {
  const nodes: Node<NodeData>[] = get(nodesAtom);
  const defaultNodes = nodes.filter((node) => node.type === "default");

  const uniqueAgentIds = new Set(
    defaultNodes
      .filter((node) => Boolean((node.data as DefaultNodeData).agentId))
      .map((node) => (node.data as DefaultNodeData).agentId!),
  );
  return Array.from(uniqueAgentIds);
});

uniqueAgentIdsAtom.debugLabel = "uniqueAgentIdsAtom";
